"use client";

import React, { createContext, useContext, useState } from "react";
import AppToast from "@/components/layouts/components/toast/Toast";

interface ToastContextProps {
  showToast: (options: AppToastOptions) => void;
}

const ToastContext = createContext<ToastContextProps | undefined>(undefined);

export const useToast = (): ToastContextProps => {
  const context = useContext(ToastContext);
  if (!context) {
    throw new Error("useToast must be used within a ToastProvider");
  }
  return context;
};

const ToastProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [toastOptions, setToastOptions] = useState<AppToastOptions>({
    message: "",
  });
  const [show, setShow] = useState(true);
  const [toastKey, setToastKey] = useState(0); // Add a state for the toast key

  const showToast = (options: AppToastOptions) => {
    if (!options.dismissible) options.dismissible = true;
    setToastOptions(options);
    setShow(true);
    setToastKey((prevKey) => prevKey + 1); // Increment the toast key to trigger a re-render
  };

  return (
    <ToastContext.Provider value={{ showToast }}>
      {children}
      {toastOptions.message && (
        <AppToast
          key={toastKey}
          show={show}
          setShow={setShow}
          options={toastOptions}
        />
      )}
    </ToastContext.Provider>
  );
};

export default ToastProvider;
